import { useState } from 'react';

const SIZES = {
  xs: { pad: '4px 8px',   fs: 11, h: 24, gap: 4, ir: 12 },
  sm: { pad: '6px 10px',  fs: 12, h: 30, gap: 5, ir: 13 },
  md: { pad: '8px 14px',  fs: 13, h: 36, gap: 6, ir: 15 },
  lg: { pad: '11px 18px', fs: 14, h: 42, gap: 8, ir: 16 },
  xl: { pad: '14px 22px', fs: 15, h: 50, gap: 10, ir: 18 },
};

const VARIANTS = {
  primary: { bg: 'var(--accent)',    color: '#fff',              border: 'transparent',     hover: 'var(--accent-600)', shadow: '0 1px 0 rgba(0,0,0,0.04), 0 4px 12px rgba(61,199,91,0.24)' },
  navy:    { bg: 'var(--navy)',      color: '#fff',              border: 'transparent',     hover: '#1e2654',            shadow: '0 1px 0 rgba(0,0,0,0.08), 0 4px 12px rgba(10,15,46,0.2)' },
  ghost:   { bg: 'transparent',      color: 'var(--text-2)',     border: 'transparent',     hover: 'var(--surface-2)',   shadow: 'none' },
  outline: { bg: 'var(--surface)',   color: 'var(--text)',       border: 'var(--border)',   hover: 'var(--surface-2)',   shadow: 'var(--shadow-xs)' },
  danger:  { bg: 'var(--danger-bg)', color: 'var(--danger)',     border: 'transparent',     hover: '#fecaca',            shadow: 'none' },
  soft:    { bg: 'var(--accent-bg)', color: 'var(--accent-600)', border: 'transparent',     hover: '#d6f5de',            shadow: 'none' },
};

export default function Btn({
  variant = 'primary',
  size = 'md',
  icon: IconC,
  iconRight: IconR,
  children,
  onClick,
  style,
  title,
  disabled,
  type = 'button',
  ...rest
}) {
  const s = SIZES[size];
  const v = VARIANTS[variant];
  const [hover, setHover] = useState(false);

  return (
    <button
      type={type}
      disabled={disabled}
      title={title}
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className="mi-btn"
      style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: s.gap,
        padding: s.pad, height: s.h, fontSize: s.fs, fontWeight: 600,
        fontFamily: 'inherit', letterSpacing: '-0.005em',
        color: v.color,
        background: hover && !disabled ? v.hover : v.bg,
        border: `1px solid ${v.border === 'transparent' ? 'transparent' : v.border}`,
        borderRadius: size === 'xl' ? 12 : size === 'lg' ? 10 : 8,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.55 : 1,
        boxShadow: v.shadow,
        transition: 'background 0.12s, transform 0.08s, box-shadow 0.12s',
        transform: hover && !disabled ? 'translateY(-0.5px)' : 'none',
        whiteSpace: 'nowrap',
        ...style,
      }}
      {...rest}
    >
      {IconC && <IconC size={s.ir} />}
      {children}
      {IconR && <IconR size={s.ir} />}
    </button>
  );
}
